import {RouterModule, Routes} from '@angular/router'
import {PUBLIC_ROUTES} from '../../../shared/routing/public.routes'
import {NgModule} from '@angular/core'
import {CategoryLandingPageComponent} from './category-landing-page.component'
import {CategoryLandingPageResolver} from './category-landing-page.resolver'
import {CategoryLandingPageContentService} from '../../../core/content/services/category-landing-page-content.service'

const routes: Routes = [
  {
    path: PUBLIC_ROUTES.CATEGORY_LANDING_PAGE.routingPath,
    component: CategoryLandingPageComponent,
    resolve: {
      content: CategoryLandingPageResolver,
    },
  },
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [CategoryLandingPageResolver, CategoryLandingPageContentService],
})
export class CategoryLandingPageRoutingModule {}
